import { Cleaner, Supervisor, Zone } from 'pdfs/zone-setup-report';
import { EZoneTargetCleaningType } from '../../enums';

export const cleanersMock: Cleaner[] = [
  { name: 'Karina Neff', email: 'karinaneff@me.com', phone: '(703) 448-2228' },
  { name: 'Scott Smith', email: 'ssmith@mycora.us', phone: '(999) 123-2228' },
];

export const supervisorsMock: Supervisor[] = [
  { name: 'Jamal Johns', email: 'jjohns@mycora.us', phone: '(703) 448-2228' },
  { name: 'Rodney Davis', email: 'rdavis@mycora.us', phone: '(999) 123-2228' },
];

export const zoneSetupsMock: Zone[] = [
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.FREQUENCY,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.FREQUENCY,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.FREQUENCY,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.FREQUENCY,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.FREQUENCY,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.FREQUENCY,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.FREQUENCY,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.FREQUENCY,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.FREQUENCY,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
  {
    type: EZoneTargetCleaningType.SCHEDULE,
    code: '231432',
    name: 'Third Floor Room #337',
    category: 'Category 001',
    interval: 'Monthly',
    frequency: 3,
  },
];
